module.exports = __webpack_public_path__ + "static/7-0876da054f7351e96760bfcc452a8b6f.jpg";